<template>
  <div class="profile">
    <div class="header">
      <div class="header_section">
        <router-link to="/camera" class="header_element header_icone mobile">
          <!--          <span class="icon icon-left-arrow icon-md"></span>-->
          <font-awesome-icon color="#00d7fe" class="reverse" icon="angle-right"/>

        </router-link>

        <h1 class="header_element ">profile</h1>

      </div>
    </div>
    <div class="content_container">
      <div class="content_section">
        <img width="100%" class="content_img" :src="user.avatar" alt="">

        <p class="content_name mobile">{{ user.name }}</p>

        <div class="user_ranking">
          <span>{{ user.rank }}</span>
          <span>{{ user.name }}</span>
          <div style="display: flex;font-size:12px;">{{ user.challenges }} <span class="icon icon-trophy icon-xs"
                                                                                 style="left:5px;"></span></div>
          <span>{{ user.score }}</span>
        </div>
        <!--        <p class="content_success ">{{ user.score }}</p>-->
        <span :class="form.response.type" v-if="form.response">{{ form.response.msg }}</span>

        <form v-on:submit.prevent="submitForm" class="form-user desktop" v-if="user.user_type==='Utilisateur'">
          <div class="form_field">
            <input type="text" v-model="form.username">
          </div>
          <div class="form_field">
            <input type="email" v-model="form.email">
          </div>
          <div class="form_field">
            <input type="password" v-model="form.password" placeholder="mot de passe">
          </div>
          <span class="error_form" v-show="form.error.mdpconf">{{ form.error.mdpconf }}</span>
          <div class="form_field" v-if="form.password !== ''" :class="{'error_input':form.error.mdpconf!==''}">
            <input type="password" v-model="form.confirmPassword" placeholder="confirmation mot de passe">
          </div>
          <button class="btn btn-primary">Modifier</button>
        </form>

        <button class="btn btn-download" v-if="user.user_type!=='Utilisateur' && this.subsection==='Pictures'"
                :class="{'active':this.selectedPictures.length > 0}" @click="downloadItem">
          Télécharger
        </button>

        <router-link to="/logout" class="desktop">
          <div class="content_element logout ">
            <span><font-awesome-icon class="content_element_icon_description" icon="sign-out-alt"/></span>
            <p class="content_element_link">Deconnexion</p>
            <span></span>
          </div>
        </router-link>
        <button class="btn btn-primary-reverse" v-if="user.user_type!=='Utilisateur'">
          Nous Contacter
        </button>
      </div>
      <div class="content_section">
        <div class="tabs desktop" :class="{'client_admin':user.user_type!=='Utilisateur'}">
          <!--          <div class="tab content_element current Gallery" data-section="Gallery" @click="showSection">-->
          <!--            <span><font-awesome-icon size="lg" data-section="Gallery" class="content_element_icon_description" icon="clone"/></span>-->
          <!--            <p class="content_element_link" data-section="Gallery">Gallerie</p>-->
          <!--          </div>-->
          <span class="tabs-slider left" @click="tabsSlider('left')" v-if="user.user_type!=='Utilisateur'"
                :class="{'active':!isLeft}"><font-awesome-icon class="reverse" icon="angle-right"/></span>
          <span class="tabs-slider right" @click="tabsSlider('right')" v-if="user.user_type!=='Utilisateur'"
                :class="{'active':isLeft}"><font-awesome-icon icon="angle-right"/></span>
          <div class="tab content_element Dashboard" :class="{'current':section==='Dashboard'}" data-section="Dashboard"
               @click="showSection" v-if="user.user_type!=='Utilisateur'">

            <font-awesome-icon size="lg" data-section="Dashboard" class="content_element_icon_description" icon="cog"/>

            <p class="content_element_link" data-section="Dashboard">Dashboard</p>
          </div>
          <div class="tab content_element Collection" :class="{'current':section==='Collection'}"
               data-section="Collection" @click="showSection">
            <div class="icon icon-head icon-white">
              <!--              <font-awesome-icon size="lg" data-section="Collection" class="content_element_icon_description" icon="theater-masks"/>-->
            </div>
            <p class="content_element_link" data-section="Collection">Masques</p>
          </div>
          <div class="tab content_element Trophies" :class="{'current':section==='Trophies'}" data-section="Trophies"
               @click="showSection">
            <div class="icon icon-trophy icon-white">
              <!--              <font-awesome-icon class="content_element_icon_description" data-section="Trophies" icon="trophy"/>-->
            </div>
            <p class="content_element_link" data-section="Trophies">Trophés</p>
          </div>
          <div class="tab content_element Games" :class="{'current':section==='Games'}" data-section="Games"
               @click="showSection">
            <!--            <div class="icon icon-game icon-white">-->
            <!--            </div>-->
            <font-awesome-icon class="content_element_icon_description" data-section="Games" size="lg" icon="dice-d20"/>


            <p class="content_element_link" data-section="Games">Games</p>
          </div>
          <div class="tab content_element ScanList" :class="{'current':section==='ScanList'}" data-section="ScanList"
               @click="showSection">
            <div class="icon icon-scan icon-white">
              <!--              <font-awesome-icon class="content_element_icon_description" data-section="Trophies" icon="trophy"/>-->
            </div>
            <p class="content_element_link" data-section="ScanList">Scan List</p>
          </div>
          <div class="tab content_element Ranking" :class="{'current':section==='Ranking'}" data-section="Ranking"
               @click="showSection">
            <div class="icon icon-rank icon-white">
              <!--              <font-awesome-icon class="content_element_icon_description" data-section="Ranking" icon="flag-checkered"/>-->
            </div>
            <p class="content_element_link" data-section="Ranking">Classements</p>
          </div>
        </div>
        <div class="tabs-content desktop">

          <component :is="section" @updateFunction="updateFunction"></component>
        </div>


        <router-link to="/dashboard" class="mobile" v-if="user.user_type!=='Utilisateur'">
          <div class="content_element">
            <span class="icon icon-picture icon-white icon-lg"></span>

            <!--            <span><font-awesome-icon size="lg" class="content_element_icon_description" icon="clone"/></span>-->
            <h3 class="content_element_link">Dashboard</h3>
            <span><font-awesome-icon size="lg" class="content_element_icon_arrow" icon="angle-right"/></span>
          </div>
        </router-link>
        <router-link to="/gallerie" class="mobile">
          <div class="content_element">
            <span class="icon icon-picture icon-white icon-lg"></span>

            <!--            <span><font-awesome-icon size="lg" class="content_element_icon_description" icon="clone"/></span>-->
            <h3 class="content_element_link">Gallerie</h3>
            <span><font-awesome-icon size="lg" class="content_element_icon_arrow" icon="angle-right"/></span>
          </div>
        </router-link>
        <router-link to="/collection" class="mobile">
          <div class="content_element">
            <span class="icon icon-head icon-white icon-lg"></span>
            <!--            <span><font-awesome-icon size="lg" class="content_element_icon_description" icon="theater-masks"/></span>-->
            <h3 class="content_element_link">Masques</h3>
            <span><font-awesome-icon size="lg" class="content_element_icon_arrow" icon="angle-right"/></span>
          </div>
        </router-link>
        <router-link to="/trophies" class="mobile">
          <div class="content_element">
            <span class="icon icon-trophy icon-white icon-lg"></span>
            <!--            <span><font-awesome-icon class="content_element_icon_description" icon="trophy"/></span>-->
            <h3 class="content_element_link">Trophés </h3>
            <span><font-awesome-icon class="content_element_icon_arrow" icon="angle-right"/></span>
          </div>
        </router-link>
        <router-link to="/scanlist" class="mobile">
          <div class="content_element">
            <span class="icon icon-scan icon-white icon-lg"></span>
            <!--            <span><font-awesome-icon class="content_element_icon_description" icon="trophy"/></span>-->
            <h3 class="content_element_link">Scan List </h3>
            <span><font-awesome-icon class="content_element_icon_arrow" icon="angle-right"/></span>
          </div>
        </router-link>
        <router-link to="/games" class="mobile">
          <div class="content_element">
            <span class="icon icon-games icon-white icon-lg"></span>
            <!--            <span><font-awesome-icon class="content_element_icon_description" icon="trophy"/></span>-->
            <h3 class="content_element_link">Games</h3>
            <span><font-awesome-icon class="content_element_icon_arrow" icon="angle-right"/></span>
          </div>
        </router-link>
        <router-link to="/ranking" class="mobile">
          <div class="content_element">
            <span class="icon icon-rank icon-white icon-lg"></span>
            <!--            <span><font-awesome-icon class="content_element_icon_description" icon="flag-checkered"/></span>-->
            <h3 class="content_element_link">Classements</h3>
            <span><font-awesome-icon class="content_element_icon_arrow" icon="angle-right"/></span>
          </div>
        </router-link>
        <router-link to="/logout" class="mobile">
          <div class="content_element logout ">
            <span><font-awesome-icon class="content_element_icon_description" size="lg" icon="sign-out-alt"/></span>
            <p class="content_element_link">Deconnexion</p>
            <span></span>
          </div>
        </router-link>


        <!--        region FEATURES RANKINGS-->
        <!--        <router-link to="/ranking">-->
        <!--          <div class="content_element">-->
        <!--            <span><font-awesome-icon class="content_element_icon_description" icon="flag-checkered"/></span>-->
        <!--            <p class="content_element_link">Classements</p>-->
        <!--            <span><font-awesome-icon class="content_element_icon_arrow" icon="angle-right"/></span>-->
        <!--          </div>-->
        <!--        endregion-->

        <!--        region FEATURES TROPHIES-->
        <!--        </router-link>-->
        <!--        <router-link to="/trophies">-->
        <!--          <div class="content_element">-->
        <!--            <span><font-awesome-icon class="content_element_icon_description" icon="trophy"/></span>-->
        <!--            <p class="content_element_link">Trophés </p>-->
        <!--            <span><font-awesome-icon class="content_element_icon_arrow" icon="angle-right"/></span>-->
        <!--          </div>-->
        <!--        </router-link>-->
        <!--        endregion-->

      </div>
    </div>
  </div>
</template>
<script>
import {store} from '../store/store';
import {mapState, mapActions} from "vuex";
import Gallery from "./Gallery";
import Ranking from "./Ranking";
import Trophies from "./Trophies";
import Collection from "./Collection";
import ScanList from "./ScanList";
import Dashboard from "./Dashboard";
import Games from "@/Views/Games";
import axios from "axios";

export default {
  name: 'profil',
  components: {
    Gallery,
    Ranking,
    Trophies,
    Collection,
    ScanList,
    Dashboard,
    Games
  },
  data() {
    return {
      section: store.getters.getUser.user_type === 'Utilisateur' ? 'Collection' : 'Dashboard',
      subsection: null,
      selectedPictures: [],
      user: store.getters.getUser,
      form: {
        username: store.getters.getUser.name,
        email: store.getters.getUser.email,
        password: '',
        confirmPassword: '',
        error: {
          username: '',
          email: '',
          password: '',
          mdpconf: ''
        },
        response: null,
      },
      isLeft: true,
    }
  },
  methods: {
    ...mapActions([
      'updateUser'
    ]),
    submitForm() {
      let {username, email, password, confirmPassword} = this.form
      if (password === confirmPassword) {

        this.updateUser(this.form)
            .then(res => {
              this.form.response = res
            })

      } else {
        this.form.error.mdpconf = 'mot de passe différent'
      }

    },
    showSection(e) {
      this.section = e.target.dataset.section
    },
    updateFunction(data) {
      this.subsection = data.subsection;
      this.selectedPictures = data.selectedPictures;

    },
    tabsSlider(goTo) {
      let tabs = document.querySelectorAll('.tabs .tab')
      let size = document.querySelector('.tab').clientWidth
      let total = size * (tabs.length - 4) - (10 * (tabs.length - 4))
      let barSize = document.querySelector('.tabs').clientWidth

      if (goTo === 'right') {
        document.querySelector('.tabs>div').style.marginLeft = "calc(-" + total + "px - 5px)";
        this.isLeft = false
      } else {
        document.querySelector('.tabs>div').style.marginLeft = 0;
        this.isLeft = true
      }
    },
    downloadItem() {

      this.selectedPictures.forEach(data => {
        axios.get('https://dev.amdeveloper.fr/api/getimage/' + data.id, {responseType: 'blob'})
            .then(function (r) {
              const url = window.URL.createObjectURL(new Blob([r.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', 'Animhead_' + data.id + '.png');
              document.body.appendChild(link);
              link.click();
            })
      })


    },
  },
  computed: {
    ...mapState([
      "masks",
      "logged",
      "user"
    ])
  },
  mounted() {
    !localStorage.getItem('user') && this.$router.push('/connexion');

  }
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap');

.header {
  padding: 10px 0;
  /*background-color: #00d7fe;*/
  display: flex;
  text-align: center;
}


.profile {
  z-index: 1;
  background: #fff;
  padding-bottom: calc(70px + env(safe-area-inset-bottom));
}

.user_ranking {
  display: flex;
  justify-content: space-between;
  width: 60%;
  border: 1px solid var(--main-dark-blue);
  border-radius: 5px;
  padding: 5px 10px;
  margin: auto;
  margin-top: 10px;
}

.header_icone {
  font-size: 30px;
  /*line-height: 80px;*/
}

.reverse {
  transform: rotateY(180deg);
}

.header_section {
  display: flex;
  align-items: center;
  text-align: center;
}

.header_section:first-child {
  justify-content: center;
  width: 100%;
}

.header_section:first-child .header_element:first-child {
  position: absolute;
  left: 10px;
}

.header_element {
  margin: 0 0 0 10px;
  color: #00d7fe;
  text-decoration: none;
}

h1.header_element {
  font-size: 3em;
  /*border-bottom:4px solid #00d7fe;*/
  padding: 0;
  position: relative;
}


.content_container {
  display: flex;
}

.content_section {
  display: flex;
  padding: 0 20px;
  flex-direction: column;

}

.content_section:first-child {
  flex: 1;
  margin-top: 0;
}

.form-user {
  margin-top: 10px;
  display: flex !important;
  flex-direction: column;
}

.form-user .form_field {
  display: flex;
  margin: 10px 0;
  flex: 1;
}

.form-user .form_field input {
  flex: 1;
  padding: 10px;
  border: 1px solid #00d6ff;
  border-radius: 10px;
}

.btn {
  flex: 1;
  padding: 10px;
  font-family: Poppins;
  /*border:none;*/
  /*background:#00d6ff;*/
  /*color:#fff;*/
  border-radius: 10px;
  margin-top: 20px;
  transition: .3s;
}

.btn:hover {
  cursor: pointer;
  /*background:#297F9E;*/
  /*color:#fff;*/
}


.content_section:last-child {
  flex: 3;
  height: 75vh;
  overflow: hidden;
}

.content_section:last-child .tabs {
  display: flex;
  justify-content: space-between;
}

.content_section:last-child .tabs > div {
  width: 20% !important;
  margin: 5px;
}

.content_section:last-child .tabs.client_admin {
  display: -webkit-box;
  position: relative;
  overflow-x: clip;
}

.tabs-slider {
  display: none;
  position: absolute;
  height: 100%;
  justify-content: center;
  align-items: center;
  z-index: 2;
  width: 20px;
  background: rgba(211, 207, 207, 0.41);
  font-size: 1.2em;
  color: grey;
  transition: .3s;

}

.tabs-slider:hover {
  color: #fff;
  cursor: pointer;
  background: var(--main-color-darkness)
}

.tabs-slider.active {
  display: flex;
}

.tabs-slider.left {
  left: 0;
}

.tabs-slider.right {
  right: 0;
}

.tabs-content {
  margin-top: 10px;
  border-top: 2px solid #00d6ff;
  height: 100%;
  overflow: scroll;
}

/* width */
.tabs-content::-webkit-scrollbar {
  width: 5px;
}

/* Handle */
.tabs-content::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 8px;
}

/* Handle on hover */
.tabs-content::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.content_name {
  text-align: center;
  color: #00d6ff;
  font-size: 35px;
  margin: 0;
  font-family: 'Bebas Neue', cursive;
  letter-spacing: 2px;
}

.content_success {
  text-align: center;
  color: #00a6d9;
  font-size: 20px;
  margin: 0;
  font-family: Poppins;
}


.content_element {
  color: white;
  border-radius: 10px;
  background-color: #00d6ff;
  /*height: 70px;*/
  padding: 10px;
  display: flex;
  width: 90%;
  margin: 10px auto;
  justify-content: space-between;
  transition: .3s;
}

.content_element:hover, .content_element.current {
  background: #297F9E;
}


.error {
  border-radius: 10px;
  font-family: Poppins;
  padding: 5px;
  background: #ff5047;
  color: #fff;
}

.warning {
  border-radius: 10px;
  font-family: Poppins;
  padding: 5px;
  background: #ffb547;
  color: #fff;
}

.succeed {
  border-radius: 10px;
  font-family: Poppins;
  padding: 5px;
  background: #65c249;
  color: #fff;
}

.error_form {
  color: #ff5047;
  font-size: 12px;
  padding: 0px 5px;
}

.error_input input {
  border-color: #ff5047 !important;
}

.logout {
  margin-top: 20px;
  background-color: #ff5047;
  border-radius: 0.5em;
}

.logout:hover {
  background: #ec5b53;
}

span {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.content_img {
  width: 150px;
  border-radius: 100%;
  height: auto;
  margin: auto;
}

.content_element_link {
  margin: auto 0;
}

.content_element_link:hover, .tab {
  cursor: pointer;
}

.desktop .content_element_link {
  width: 100%;
  text-align: center;
}


a {
  text-decoration: none;
}

a.addinsta {
  color: #00a6d9;
}

.mobile {
  display: none;
}

.desktop {
  display: block;
}


@media screen and (max-width: 750px) {
  .mobile {
    display: block;
  }

  .desktop {
    display: none !important;
  }

  .content_container {
    margin-top: 30px;
    flex-direction: column;
  }
}

@media screen and (min-width: 750px) {

  .content_container {
    padding: 0 40px;
  }

  .content_section {
    width: 70%;
    margin: auto;
    margin-top: 30px;
  }
}
</style>
